import React from 'react';
import { FaDumbbell, FaSpa, FaGlassCheers, FaTableTennis , FaUtensils, FaBuilding } from 'react-icons/fa';

const services = [
  { 
    icon: <FaSpa />, 
    title: { 
      en: 'Spa & Massage', 
      am: 'ስፓ እና መታሸት አገልልግሎተ' 
    },
    desc: { 
      en: 'World-class relaxation services and steam rooms.', 
      am: 'የእንፋሎት ክፍሎች።' 
    }
  },
  { 
    icon: <FaDumbbell />, 
    title: { 
      en: 'Gymnasium', 
      am: 'ጂምናዚየም' 
    },
    desc: { 
      en: 'Modern gym service with the help of professional trainers.', 
      am: 'በሙያው  በተካኑ አሰልጣኞች በመታገዝ ዘመናዊ የጂምናዚየም አገልግሎት።' 
    }
  },
  { 
    icon: <FaTableTennis />, 
    title: { 
      en: 'Ground Tennis', 
      am: 'መሬት ቴኒስ' 
    },
    desc: { 
      en: 'A comfortable and fully equipped tennis court for regular play, practice, and competitive use.', 
      am: 'ለዘወትር መጫዎቻ፣መለማመጃ እና ስፓርታዊ መወዳደሪያ አገልግሎት  የሚውል ምቹና የተሟላ የሜዳ ተኒስ።' 
    }
  },
  { 
    icon: <FaUtensils />, 
    title: { 
      en: 'Bar & Restaurant', 
      am: 'ባር እና ሬስቶራንት' 
    },
    desc: { 
      en: 'Hotel and bar service with a variety of food and beverage options that are prepared with quality and maintain their standards.', 
      am: 'በጥራት የሚዘጋጁና ደረጃቸዉን የጠበቁ የተለያዩ የምግብ እና የመጠጥ ምርጫዎች ያላቸው  የሆቴል።' 
    }
  },
  { 
    icon: <FaGlassCheers />, 
    title: { 
      en: 'Event Hosting', 
      am: 'የዝግጅት ፐሮግራም' 
    },
    desc: { 
      en: 'Complete catering services for weddings, birthdays, graduations, and other ceremonies at affordable prices', 
      am: ' የጋብቻ፣ የልደት ፣ የትምህርት ምርቃት አና ለሌሎች ስነ-ስርአቶች የተሟላ የመስተንግዶ ዝግጅቶች በተመጣጣኝ ዋጋ።' 
    }
  },
  { 
    icon: <FaBuilding />, 
    title: { 
      en: 'Large Event Hall', 
      am: 'ትልቅ የዝግጅት አዳራሽ' 
    },
    desc: { 
      en: 'A beautifully decorated and furnished in the field and hall  for small and big occasions with catering and non-catering facilities.', 
      am: 'በመስክና በአዳራሽ ለሚከኑ ከትንሽ እስከ ከፍተኛ  ዝግጅቶችን ለማከናወን የሚያስችል ምቹ ፣ የተሟላ፣ የተዋበና የተዘጋጀ የአዳራሽ አቅርቦት ከተሟላ መስተንግዶ እና ከመስተንግዶ ውጭ።' 
    }
  }
];

const AboutFacilities = ({ language }) => {
  return (
    <section className="py-5 bg-light" id="facilities">
      <div className="container">
<h2 className="text-center fw-bold mb-5">
  {language === 'en' ? 'Facilities & Services' : 'የመገልገያ ምሳሪያዎች  እና  የምንሰጣቸው  አገልግሎቶች አይነቶች'}
</h2>       
 <div className="row" data-aos="fade-up">
          {services.map((item, index) => (
            <div className="col-md-4 mb-4 text-center" key={index}>
              <div className="p-4 bg-white shadow-sm rounded h-100">
<div className="text-primary mb-3" style={{ fontSize: '2rem' }}>
  {item.icon}
</div>
                <h5 className="fw-bold">{item.title[language]}</h5>
                <p className="text-muted">{item.desc[language]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFacilities;
